import React from "react";
import { CheckCircle2, Clock, XCircle, AlertTriangle, Loader2 } from "lucide-react";
import { useLanguage } from "@/shared/components/shared/LanguageContext";

const statusConfigDefault = {
  success: { icon: CheckCircle2, bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", label: "Success" },
  pending: { icon: Clock, bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", label: "Pending" },
  processing: { icon: Loader2, bg: "bg-blue-50", text: "text-blue-700", border: "border-blue-200", label: "Processing", animate: true },
  failed: { icon: XCircle, bg: "bg-red-50", text: "text-red-700", border: "border-red-200", label: "Failed" },
  expired: { icon: AlertTriangle, bg: "bg-slate-50", text: "text-slate-700", border: "border-slate-200", label: "Expired" },
  delivered: { icon: CheckCircle2, bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", label: "Completed" },
  retrying: { icon: Loader2, bg: "bg-orange-50", text: "text-orange-700", border: "border-orange-200", label: "Retry", animate: true },
};

const getStatusConfig = (t) => {
  if (!t) return statusConfigDefault;
  return {
    success: { ...statusConfigDefault.success, label: t("success") },
    pending: { ...statusConfigDefault.pending, label: t("pending") },
    processing: { ...statusConfigDefault.processing, label: t("processing") },
    failed: { ...statusConfigDefault.failed, label: t("failed") },
    expired: { ...statusConfigDefault.expired, label: t("expired") },
    delivered: { ...statusConfigDefault.delivered, label: t("completed") },
    retrying: { ...statusConfigDefault.retrying, label: t("retry") },
  };
};

export default function StatusBadge({ status, size = "default" }) {
  let t = null;
  try {
    const langContext = useLanguage();
    t = langContext?.t;
  } catch (e) {
    // Not wrapped in LanguageProvider
  }
  const statusConfig = getStatusConfig(t);
  const statusKey = (status || '').toLowerCase();
  const config = statusConfig[statusKey] || statusConfig.pending;
  const Icon = config.icon;

  const sizeClasses = size === "small" 
    ? "px-2 py-0.5 text-xs gap-1" 
    : "px-2.5 py-1 text-xs gap-1.5";

  return (
    <span
      className={`inline-flex items-center rounded-full border font-medium ${config.bg} ${config.text} ${config.border} ${sizeClasses}`}
    >
      <Icon className={`h-3 w-3 ${config.animate ? "animate-spin" : ""}`} />
      {config.label}
    </span>
  );
}